module.exports = __webpack_public_path__ + "static/media/MLG-Weiss.d654817d.png";